import React from 'react';

export function TimelineCard({ title = 'Linha do Tempo', events = [] }) {
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', display: 'block', marginBottom: 14 }}>
        {title}
      </span>

      <div style={{ position: 'relative', paddingLeft: 20 }}>
        {/* Vertical line */}
        <div style={{
          position: 'absolute', left: 6, top: 6, bottom: 6,
          width: 1, background: 'rgba(56,189,248,0.15)',
        }} />

        {events.map((ev, i) => {
          const isLast = i === events.length - 1;
          return (
            <div key={i} style={{ position: 'relative', marginBottom: isLast ? 0 : 14 }}>
              {/* Dot */}
              <div style={{
                position: 'absolute', left: -17, top: 4,
                width: 7, height: 7, borderRadius: '50%',
                background: ev.done ? '#10b981' : 'rgba(56,189,248,0.3)',
                border: `1.5px solid ${ev.done ? '#10b981' : 'rgba(56,189,248,0.5)'}`,
                boxShadow: ev.done ? '0 0 6px rgba(16,185,129,0.4)' : 'none',
              }} />

              {/* Content */}
              {ev.date && (
                <div style={{ fontSize: 10, color: 'rgba(56,189,248,0.55)', letterSpacing: '.03em', marginBottom: 2 }}>
                  {ev.date}
                </div>
              )}
              <div style={{ fontSize: 12.5, color: ev.done ? 'rgba(220,228,255,0.78)' : 'rgba(148,163,184,0.65)', lineHeight: 1.4 }}>
                {ev.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
